/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unarchiveconfirmtitle2Inputs */



/**
* | output |
* | --- |
* | "Bring back to the main list?" |
*
* @param {Unarchiveconfirmtitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const unarchiveconfirmtitle2 = /** @type {((inputs?: Unarchiveconfirmtitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unarchiveconfirmtitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Bring back to the main list?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Devolver a la lista principal?")
	return /** @type {LocalizedString} */ ("Вернуть на главную?")
});
export { unarchiveconfirmtitle2 as "unarchiveConfirmTitle" }